import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { KeyRound } from "lucide-react";
import { BrandLogo } from "@/components/Brand";
import { useAuth } from "@/context/AuthContext";
import { isAdminRole } from "@/lib/roles";
import { AccessCodeForm } from "@/components/AccessCodeForm";

const AccessLogin = () => {
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  useEffect(() => { if (!loading && user) navigate(isAdminRole(user) ? "/admin" : "/dashboard"); }, [user, loading, navigate]);

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex flex-col">
      <header className="h-24 flex items-center px-5 sm:px-8">
        <BrandLogo testId="access-logo" />
      </header>

      <div className="flex-1 flex items-center justify-center px-5 py-10">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
          className="w-full max-w-md bg-white rounded-2xl border border-slate-200 p-8">
          <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center mb-5">
            <KeyRound className="w-6 h-6 text-primary" />
          </div>
          <h1 className="font-heading font-extrabold text-2xl text-slate-900">Enter your access code</h1>
          <p className="font-body text-sm text-slate-500 mt-2">
            Use the unique code and one-time password you received. If you've already started, the same code and password let you pick up where you left off.
          </p>
          <div className="mt-6"><AccessCodeForm /></div>
          <p className="font-body text-xs text-slate-400 mt-6 text-center">
            Don't have a code? Contact your program administrator.
          </p>
        </motion.div>
      </div>
    </div>
  );
};

export default AccessLogin;
